import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';

function CreateTaskScreen() {
    const navigate = useNavigate();
    const [formFields, setFormFields] = useState({'task_title': '', 'task_link': '', 'due_date': '', 'participants': 'ALL'});
    const { setTostMessage } = useContext(TostMessageContext);
    const [cookies, setCookie, removeCookie] = useCookies();
    const {setUserProfile, userProfile, logOutFunction, reloadUser} = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const submit = async () => {
        if (formFields?.participants == "" || formFields?.due_date == "" || formFields?.task_link == "" || formFields?.task_title == "") {
            setTostMessage({
                messageType: "warning",
                message: 'Please fill required fields',
            });
            return;
        }

        const formData = new FormData();
        formData.append("group_id", location?.state?.group_id);
        formData.append("sub_id", location?.state?.subscription_id);
        formData.append("category", location?.state?.category);
        formData.append("title", formFields?.task_title);
        formData.append("link", formFields?.task_link);
        formData.append("due_date", formFields?.due_date);
        formData.append("participants", formFields?.participants);
    
        setLoading(true);
        try {
            const response = await axios.post(base_url + '/tasks/create_task.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoading(false);
                setTostMessage({
                    messageType: "success",
                    message: response.data.response,
                });
                setFormFields({'first_name': '', 'last_name': '', 'middle_name': '', 'dob': ''});
                window.history.back()
            } else {
                setLoading(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='flex flex-row justify-between'>
                    <div className="w-full px-10 py-[4rem] bg-[#FAFAFA] rounded-lg">
                        <h1 className="text-2xl font-bold text-gray-800 mb-6">Create Task for {location?.state?.language} ({location?.state?.level_name})</h1>
                        <div className="flex inline-flex flex-wrap w-full justify-between">
                            <div className='w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Task Title <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Enter title (e.g Learn to spell)"
                                    onChange={(e) => setFormFields({...formFields, task_title: e.target.value})}
                                />
                            </div>
                            
                            <div className='w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Task Link <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Enter URL (e.g Link to video or blooket)"
                                    onChange={(e) => setFormFields({...formFields, task_link: e.target.value})}
                                />
                            </div>
                            
                            <div className='w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Select Participants <span className="text-red-500">*</span>
                                </label>
                                <select onChange={(e) => setFormFields({...formFields, participants: e.target.value})} className="border border-gray-300 h-[61px] px-3 py-2 rounded-md text-sm text-gray-700 w-full focus:outline-none focus:ring-2 focus:ring-yellow">
                                    <option value="">Select option</option>
                                    {location?.state?.category == "GROUP" && <option value="ALL">All Students</option>}
                                    {location?.state?.students?.map((student, index) => 
                                        <option key={index} value={student.student_id}>{student.student_name}</option>
                                    )}
                                </select>
                            </div>
                            
                            <div className='w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Due Date <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <input
                                        type="date"
                                        className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                        placeholder="Choose date"
                                        onChange={(e) => setFormFields({...formFields, due_date: e.target.value})}
                                    />
                                </div>
                            </div>

                            <div className='w-full mt-3 flex justify-end'>
                                <ButtonSmall onPress={() => submit()} label={'Save'} loading={loading} />
                            </div>
                        </div>
                        </div>
                </div>
            </main>
        </div>
    </div>
  );
}

export default CreateTaskScreen;
